import { format, parseISO } from "date-fns";
import { useState } from "react";
import { useEffect } from "react";
import { when } from "utils";

export function useISOCountDown(isoDate: string, initial = "", callback?: (iso: string, expired: boolean) => void) {
  const [timer, setTimer] = useState(initial);
  const [expired, setExpired] = useState(false);

  const time = parseISO(isoDate).getTime();

  useEffect(() => {
    const x = setInterval(function () {
      // Get today's date and time
      const now = new Date().getTime();
      // Find the distance between now and the count down date
      const distance = time - now;
      // Time calculations for days, hours, minutes and seconds

      !!callback && callback(new Date(distance).toISOString(), distance < 0);

      // const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      // Display the result in the element with id="demo"
      // setTimer(`${String(minutes).length < 2 ? "0" : ""}${minutes} : ${String(seconds).length < 2 ? "0" : ""}${seconds}mins`);

      setTimer(format(distance, "mm:ss ").concat(when(seconds < 60, "secs", "mins")));

      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        setTimer("00:00");
        setExpired(true);
      }
    }, 1000);

    return () => clearInterval(x);
  }, [time, callback]);

  return { timer, expired };
}
